import { render, staticRenderFns } from "./BlindBoxList.vue?vue&type=template&id=18705c8d&scoped=true"
import script from "./BlindBoxList.vue?vue&type=script&lang=js"
export * from "./BlindBoxList.vue?vue&type=script&lang=js"
import style0 from "./BlindBoxList.vue?vue&type=style&index=0&id=18705c8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18705c8d",
  null
  
)

export default component.exports